module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['row', _vm.name],
    staticStyle: {
      "height": "50px"
    }
  }, [_c('div', {
    staticClass: "col-2 corner-rl icon"
  }, [_c('base-icon', {
    attrs: {
      "name": (_vm.icon ? _vm.icon : _vm.name)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2",
    class: {
      zero: (_vm.data.total == 0)
    }
  }, [_vm._v(_vm._s(_vm.data.total))]), _vm._v(" "), _c('div', {
    staticClass: "col-2 late",
    class: {
      zero: (_vm.data.late == 0)
    }
  }, [_vm._v(_vm._s(_vm.data.late))]), _vm._v(" "), _c('div', {
    staticClass: "col-2 at-risk",
    class: {
      zero: (_vm.data.atRisk == 0)
    }
  }, [_vm._v(_vm._s(_vm.data.atRisk))]), _vm._v(" "), _c('div', {
    staticClass: "col-2 on-time corner-r",
    class: {
      zero: (_vm.data.onTime == 0)
    }
  }, [_vm._v(_vm._s(_vm.data.onTime))]), _vm._v(" "), _c('div', {
    staticClass: "col-2 upcoming",
    class: {
      zero: (_vm.data.upcoming == 0)
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.data.upcoming))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b8ffba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/ActiveShipmentsRow.vue
// module id = 726
// module chunks = 0